import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Router} from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class StaticStampService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    listTemplate(query?: any)
    {
       return this.get("/static/templates",query);
    }

    detailTemplate(template_id)
    {
        return this.get("/static/templates/"+template_id);
    }

    listStamp(query)
    {
        return this.get("/static-stamps", query);
    }

    createStamp(body) {
        return this.post('/static-stamps', body)
    }

    updateStamp(stamp_id, body) {
        return this.put('/static-stamps/'+stamp_id, body);
    }

    historyStamp(stamp_id, options: any = {}) {
        return this.get('/static/history/' + stamp_id, options)
    }

    reportScan(stamp_id, options: any = {}) {
        return this.get('/static/report-scan/'+stamp_id, options);
    }

    reportCity(stamp_id, options: any = {}) {
        return this.get('/static/report-city/' + stamp_id, options);
    }

    allHistoryStamp(options: any = {}) {
        return this.get('/static/all-history', options);
    }

    allStamp() {
        return this.get('/static/all-stamp');
    }
}


// WEBPACK FOOTER //
// /app/src/app/common/services/StaticStamp.service.ts